import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { errorTypes } from '@/utility/validation'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'
import PageLoader from '@/components/common/PageLoader'

const OnboardNominee: React.FC<OnboardTabProps> = ({ isLoading, handleNextStep }) => {
    const methods = useFormContext()
    const { register, watch, setValue, formState: { errors } } = methods

    return (
        <>
            {isLoading ? <PageLoader /> : (
                <div className='space-y-8'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <FormField
                            type='select'
                            label="Relation Type"
                            value={watch('nomineeRelation')}
                            {...register('nomineeRelation', {
                                required: 'This field is Required',
                            })}
                            required
                            error={errors?.nomineeRelation?.message as string}
                            placeholder="Select Relation Type"
                            options={[
                                { value: 'Father', label: 'Father' },
                                { value: 'Mother', label: 'Mother' },
                                { value: 'Spouse', label: 'Spouse' },
                                // { value: 'Wife', label: 'Wife' },
                                // { value: 'Husband', label: 'Husband' },
                                { value: 'Brother', label: 'Brother' },
                                { value: 'Sister', label: 'Sister' },
                            ]}
                        />
                        <FormField
                            type='text'
                            label="Nominee Name"
                            placeholder="Enter Name"
                            {...register('nomineeName', {
                                required: 'This field is Required',
                                ...errorTypes.name,
                            })}
                            maxLength={30}
                            required
                            error={errors?.nomineeName?.message as string}
                        />
                        <FormField
                            type='email'
                            label="Email Id"
                            placeholder="Enter Email Id"
                            {...register('nomineeEmail', {
                                required: 'This field is Required',
                                ...errorTypes.email,
                            })}
                            required
                            error={errors?.nomineeEmail?.message as string}
                        />
                        <FormField
                            type='text'
                            label="Address"
                            placeholder="Enter Address"
                            {...register('nomineeAddress', {
                                required: 'This field is Required',
                                ...errorTypes.address
                            })}
                            maxLength={100}
                            required
                            error={errors?.nomineeAddress?.message as string}
                        />
                        <FormField
                            type='text'
                            label="Phone No."
                            maxLength={10}
                            placeholder="Enter Phone No."
                            {...register('nomineePhone', {
                                required: 'This field is Required',
                                ...errorTypes.phone,

                            })}
                            required
                            error={errors?.nomineePhone?.message as string}
                        />
                        <FormField
                            type='text'
                            label="Nominee Share Percentage (%)"
                            placeholder="Enter Percentage (0 - 100)"
                            maxLength={3}
                            {...register('nomineePercentage', {
                                required: 'This field is Required',
                                onChange: (e) => {
                                    const cleaned = (e.target.value || '').replace(/\D/g, '').slice(0, 3);
                                    setValue('nomineePercentage', cleaned, { shouldValidate: true });
                                },
                                validate: (val) => {
                                    if (val === '' || val === null || val === undefined) return 'This field is Required';
                                    const num = Number(val);
                                    if (isNaN(num)) return 'Enter a valid number';
                                    if (num < 0 || num > 100) return 'Percentage must be between 0 and 100';
                                    return true;
                                },
                            })}
                            required
                            error={errors?.nomineePercentage?.message as string}
                        />
                    </div>
                    <div className="flex justify-end mt-6">
                        <Button
                            type="button"
                            onClick={() => handleNextStep("nominee", 'tab8', ['nomineeRelation', 'nomineeName', 'nomineePhone', 'nomineeDob', 'nomineeAddress', 'nomineeEmail', 'nomineePercentage'])}
                            disabled={isLoading}
                        >
                            {isLoading ? <Spinner /> : 'Save and Continue'}
                        </Button>
                    </div>
                </div>
            )}
        </>
    )
}

export default OnboardNominee
